<template>
  <div class="product-card__view" ref="container">
    <swiper
      class="slider slider_main"
      :slidesPerView="1"
      :thumbs="{ swiper: thumbsSwiper }"
      :modules="modules"
      @slideChange="change"
      :effect="'fade'"
    >
      <swiper-slide v-for="slide in getMedia" :key="slide">
        <div class="product-card__media relative">
          <a
            v-if="slide.type === 'image' || slide.type === 'main'"
            :href="slide.sizes.full"
            data-fancybox="gallery"
            data-preload="false"
            @mousemove="zoomMouseMove"
            @mouseleave="zoomMouseLeave"
            class="product-card__image h-100 w-100 d-block"
          >
            <img :src="slide.sizes.default" alt="" />
          </a>
          <a
            v-if="slide.type === 'video_call'"
            href="javascript:void(0);"
            onclick="openCallPopup()"
            class="product-card__image h-100 w-100 d-block"
          >
            <img :src="slide.url" alt="" />
          </a>
          <a
            v-if="slide.type === 'video'"
            :href="slide.url"
            data-fancybox="gallery"
            data-preload="false"
            :data-thumb="slide.preview"
            class="product-card__image h-100 w-100"
          >
            <Video :url="slide.url" className="h-100 video-main" />
          </a>
          <a
            v-if="slide.type === 'video_360'"
            :href="slide.url"
            data-fancybox="gallery"
            data-preload="false"
            class="product-card__image h-100 w-100"
          >
            <Video :url="slide.url" className="h-100 video-main" />
          </a>
          <a
            v-if="slide.type === 'video_review'"
            :href="slide.url"
            data-fancybox="gallery"
            data-preload="false"
            :data-thumb="slide.preview"
            class="product-card__image h-100 w-100"
          >
            <Video :url="slide.url" className="h-100 video-main" />
          </a>
        </div>
      </swiper-slide>
    </swiper>
  </div>
  <div class="product-card__preview mt-xl-8 mt-sm-20 mb-sm-24">
    <swiper
      class="slider slider_preview"
      @swiper="setThumbsSwiper"
      :spaceBetween="16"
      :freeMode="true"
      :watchSlidesProgress="true"
      :navigation="true"
      :modules="modules"
      :slidesPerView="'auto'"
      :centeredSlides="true"
      :loop="true"
      :breakpoints="{
        '577': {
          centeredSlides: false,
          loop: false,
        },
      }"
    >
      <swiper-slide v-for="slide in getMedia" :key="slide">
        <div
          v-if="slide.type === 'image' || slide.type === 'main'"
          class="product-card__thumb hover-stroke radius-sm"
        >
          <img
            class="img-cover d-lg-none"
            :src="slide.sizes.preview"
            alt="product"
          />
          <Icon
            iconName="icon-slider-circle"
            className="icon-8 d-none d-lg-block"
          />
        </div>
        <div
          v-if="slide.type === 'video_call'"
          class="product-card__thumb hover-stroke radius-sm"
        >
          <img class="img-cover d-lg-none" :src="slide.preview" alt="product" />
          <Icon
            iconName="icon-slider-circle"
            className="icon-8 d-none d-lg-block"
          />
        </div>
        <div
          v-if="slide.type === 'video'"
          class="product-card__thumb hover-stroke radius-sm"
        >
          <img class="img-cover d-lg-none" :src="slide.preview" alt="product" />
          <div
            class="product-card__video-button d-flex d-flex_middle d-flex_center d-sm-none"
          >
            <img src="./../../assets/img/video-play.svg" alt="Видео" />
          </div>
          <Icon
            iconName="icon-slider-play"
            className="icon-8 d-none d-lg-block"
          />
        </div>
        <div
          v-if="slide.type === 'video_360'"
          class="product-card__thumb hover-stroke radius-sm"
        >
          <img
            class="img-cover d-lg-none"
            src="./../../assets/img/360.png"
            alt="360"
          />
          <Icon
            iconName="icon-slider-circle"
            className="icon-8 d-none d-lg-block"
          />
        </div>
        <div
          v-if="slide.type === 'video_review'"
          class="product-card__thumb hover-stroke radius-sm"
        >
          <img class="img-cover d-lg-none" :src="slide.preview" alt="product" />
          <div
            class="product-card__video-button d-flex d-flex_middle d-flex_center d-sm-none"
          >
            <img src="./../../assets/img/video-review.svg" alt="Видео обзор" />
          </div>
          <Icon
            iconName="icon-slider-play"
            className="icon-8 d-none d-lg-block"
          />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { ref } from "vue";
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

import { Fancybox } from "@fancyapps/ui";

import {
  EffectFade,
  FreeMode,
  Navigation,
  Thumbs,
  Pagination,
} from "swiper/modules";

import Video from "../Video/Video.vue";
import Icon from "../Icon/Icon.vue";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";

export default {
  name: "SliderMain",
  components: {
    Swiper,
    SwiperSlide,
    Video,
    Icon,
  },
  setup() {
    const thumbsSwiper = ref(null);

    const setThumbsSwiper = (swiper) => {
      thumbsSwiper.value = swiper;
    };
    const store = useProductStore();

    return {
      thumbsSwiper,
      setThumbsSwiper,
      store,
      modules: [EffectFade, FreeMode, Navigation, Thumbs, Pagination],
    };
  },
  props: {
    options: {
      type: Object,
      default() {
        return {
          preload: false,
          Thumbs: {
            type: "classic",
            thumbTpl: function () {
              return (
                '<button class="f-thumbs__slide__button" type="button" aria-label="{{GOTO}}">' +
                '<img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" />' +
                "</button>"
              );
            },
          },
        };
      },
    },
  },
  mounted() {
    document.documentElement.style.setProperty("--fancybox-zIndex", "2550");
    Fancybox.bind(this.$refs.container, "[data-fancybox]", {
      ...(this.options || {}),
    });
  },
  updated() {
    this.$nextTick(function () {
      Fancybox.unbind(this.$refs.container);
      Fancybox.close();
      Fancybox.bind(this.$refs.container, "[data-fancybox]", {
        ...(this.options || {}),
      });
    });
  },
  unmounted() {
    Fancybox.destroy();
  },
  computed: {
    ...mapState(useProductStore, ["getMedia"]),
    getMediaLength() {
      return this.getMedia?.length;
    },
  },
  methods: {
    change(swiper) {
      let slide = swiper.slides[swiper.activeIndex];
      let currentVideo = slide.querySelector("video");

      this.store.setMainActiveSlide(swiper.activeIndex);

      this.stopVideo();

      if (currentVideo !== null) {
        currentVideo.play();
      }
    },
    zoomMouseMove(e) {
      let image = e.target;
      if (image.tagName !== "IMG") return;

      let x = (e.offsetX / image.offsetWidth) * 100;
      let y = (e.offsetY / image.offsetHeight) * 100;

      image.style.transformOrigin = `${x}% ${y}%`;
      image.style.transform = "scale(2)";
    },
    zoomMouseLeave(e) {
      let image = e.target.querySelector("img");
      image.style.transformOrigin = "center";
      image.style.transform = "scale(1)";
    },
    stopVideo() {
      let media = Array.prototype.slice.apply(
        document.querySelectorAll("audio,video")
      );
      media.forEach(function (player) {
        player.pause();
      });
    },
  },
};
</script>
